import React, { useState } from 'react';
import { LinkRequest } from '../../services/auth';

interface LinkRequestBannerProps {
  requests: LinkRequest[];
  onRespond: (requestId: string, action: 'accept' | 'decline') => Promise<string>;
}

export const LinkRequestBanner: React.FC<LinkRequestBannerProps> = ({ requests, onRespond }) => {
  const [loadingId, setLoadingId] = useState<string | null>(null);
  const [resultMessages, setResultMessages] = useState<Record<string, { message: string; type: 'accept' | 'decline' }>>({});

  const handleRespond = async (requestId: string, action: 'accept' | 'decline') => {
    setLoadingId(requestId);
    try {
      const message = await onRespond(requestId, action);
      setResultMessages((prev) => ({ ...prev, [requestId]: { message, type: action } }));
    } finally {
      setLoadingId(null);
    }
  };

  if (requests.length === 0 && Object.keys(resultMessages).length === 0) return null;

  return (
    <div className="link-request-banners">
      {/* Show result messages for responded requests */}
      {Object.entries(resultMessages).map(([id, { message, type }]) => (
        <div key={id} className={`link-request-banner ${type === 'accept' ? 'banner-accepted' : 'banner-declined'}`}>
          <div className="link-request-info">{message}</div>
        </div>
      ))}

      {/* Show pending requests */}
      {requests
        .filter((req) => !resultMessages[req.id])
        .map((req) => (
          <div key={req.id} className="link-request-banner">
            <div className="link-request-info">
              <strong>{req.parent_name || 'A parent'}</strong>
              <span> has requested to follow your learning progress. If you accept, they&apos;ll be able to see how you&apos;re doing &mdash; things like which topics you&apos;re working on, how you&apos;re improving, and where you might need extra help.</span>
            </div>
            <div className="link-request-actions">
              <button
                className="btn-accept"
                onClick={() => handleRespond(req.id, 'accept')}
                disabled={loadingId === req.id}
              >
                Accept
              </button>
              <button
                className="btn-decline"
                onClick={() => handleRespond(req.id, 'decline')}
                disabled={loadingId === req.id}
              >
                Decline
              </button>
            </div>
          </div>
        ))}
    </div>
  );
};
